import * as R from "ramda";
import { NOT_REQUIRED_STATUS } from "./constants";
import moment from "moment";

export const extractFilter = (body) => {
  return {
    startNextAppointment: !R.isNil(body?.appointmentDate?.tanggalAwal)
      ? body?.appointmentDate?.tanggalAwal
      : null,
    endNextAppointment: !R.isNil(body?.appointmentDate?.tanggalAkhir)
      ? body?.appointmentDate?.tanggalAkhir
      : null,
    startLastDateFollowUp: !R.isNil(body?.fuDate?.tanggalAwal)
      ? body?.fuDate?.tanggalAwal
      : null,
    endLastDateFollowUP: !R.isNil(body?.fuDate?.tanggalAkhir)
      ? body?.fuDate?.tanggalAkhir
      : null,
    startDate: !R.isNil(body?.tanggalProspek?.tanggalAwal)
      ? body?.tanggalProspek?.tanggalAwal
      : !R.isNil(body?.startDate)
      ? body?.startDate
      : null,
    endDate: !R.isNil(body?.tanggalProspek?.tanggalAkhir)
      ? body?.tanggalProspek?.tanggalAkhir
      : !R.isNil(body?.endDate)
      ? body?.endDate
      : null,
    prospectCategory: !R.isEmpty(body?.prospectCategory)
      ? body.prospectCategory?.value
      : null,
    prospectKind: !R.isEmpty(body?.prospectKind)
      ? body.prospectKind?.value
      : null,
    prospectSource: !R.isEmpty(body?.prospectSource)
      ? body.prospectSource?.value
      : null,
    idProvince: !R.isNil(body?.idProvince) ? body.idProvince : null,
    idKabkot: !R.isNil(body?.idKabkot) ? body.idKabkot : null,
    kecamatan: !R.isNil(body?.kecamatan) ? body.kecamatan : null,
    kelurahan: !R.isNil(body?.kelurahan) ? body.kelurahan : null,
    kodePos: !R.isNil(body?.kodePos) ? body.kodePos : null,
    memberLevel: !R.isEmpty(body?.memberLevel) ? body.memberLevel?.value : null,
    loyaltyLevel: !R.isEmpty(body?.loyaltyLevel)
      ? body.loyaltyLevel?.value
      : null,
    facebook: !R.isEmpty(body?.facebook) ? body.facebook?.value : null,
    instagram: !R.isEmpty(body?.instagram) ? body.instagram?.value : null,
    linkedin: !R.isEmpty(body?.linkedin) ? body.linkedin?.value : null,
    x: !R.isEmpty(body?.x) ? body.x?.value : null,
    tiktok: !R.isEmpty(body?.tiktok) ? body.tiktok?.value : null,
    hobby: !R.isEmpty(body?.hobby)
      ? body?.hobby?.map((item) => item.value)
      : null,
    interest: !R.isEmpty(body?.interest)
      ? body?.interest?.map((item) => item.value)
      : null,
    kodeCabang: !R.isNil(body?.kodeCabang?.value)
      ? body.kodeCabang?.value
      : !R.isNil(body?.kodeCabang)
      ? body?.kodeCabang
      : null,
    prospectName: !R.isNil(body?.prospectName) ? body.prospectName : null,
    sourceCabang: !R.isNil(body?.sourceCabang) ? body.sourceCabang : null,
    ownerProspect: !R.isNil(body?.ownerProspect) ? body.ownerProspect : null,
    lastSeller: !R.isNil(body?.lastSeller) ? body.lastSeller : null,
    status: !R.isNil(body?.status) ? body.status : null,
    lastFollowUpBy: !R.isNil(body?.lastFollowUpBy) ? body.lastFollowUpBy : null,
    information: !R.isNil(body?.information) ? body.information : null,
    nama: !R.isNil(body?.nama) ? body.nama : null,
    nik: !R.isNil(body?.nik) ? body.nik : null,
    handPhoneNumber: !R.isNil(body?.handPhoneNumber)
      ? body.handPhoneNumber
      : null,
    alamat: !R.isNil(body?.alamat) ? body.alamat : null,
    comparator: !R.isEmpty(body?.operator) ? body?.operator?.value : null,
    overdue: !R.isNil(body?.operator) ? Number(body?.overdue || 0) : null,
    memberId: !R.isNil(body?.memberId) ? body.memberId : null,
  };
};

export const validateField = (values) => {
  const errors = {};

  Object.entries(values).forEach(([key, value]) => {
    if (
      key === "nextAppointmentDate" &&
      NOT_REQUIRED_STATUS.includes(values.followUpStatus?.value?.toUpperCase())
    ) {
      return;
    }
    if (key === "followUpMethod" && values.followUpStatus?.value === "DROP") {
      return;
    }
    if (key === "cancelReason" && values.followUpStatus?.value !== "DROP") {
      return;
    }
    if (value === null || value === undefined) {
      errors[key] = "Field belum diisi";
    } else if (
      typeof value === "object" &&
      value !== null &&
      "value" in value
    ) {
      if (
        value?.value === null ||
        value?.value === undefined ||
        value?.value === ""
      ) {
        errors[key] = "Field belum diisi";
      } else {
        errors[key] = null;
      }
    } else {
      errors[key] = null;
    }
  });
  console.log(errors);

  return Object.keys(errors).some((key) => errors[key] !== null)
    ? errors
    : null;
};

export const constructPayloadSubmit = ({
  controls,
  selectedCabang,
  hobbyRaw,
  interestRaw,
  auth,
}) => {
  const hobbyList = controls?.hobby?.map((item) => item.value) || [];
  const interestList = controls?.interest?.map((item) => item.value) || [];

  return {
    prospectId: null,
    kodeCabang: selectedCabang?.value,
    dataProspectCustomer: {
      dataCustomer: {
        customerId: controls?.customerId || null,
        name: controls?.name,
        nik: controls?.nik,
        address: controls?.address,
        provinceId: controls?.provinceId?.value,
        kabkotId: controls?.kabkotId?.value,
        kecamatanId: controls?.kecamatanId?.value,
        kelurahanId: controls?.kelurahanId?.value,
        job1: controls?.job1?.value,
        job2: controls?.job2?.value,
        religion: controls?.religion?.value,
        hpNumber1: controls?.hpNumber1,
        hpNumber2: controls?.hpNumber2,
        gender: controls?.gender?.value,
        email: controls?.email,
        instagram: controls?.instagram,
        facebook: controls?.facebook,
        linkedin: controls?.linkedin,
        x: controls?.twitter,
        tiktok: controls?.tiktok,
        characterDisc: controls?.discCategory?.value,
        hobby: hobbyRaw
          ?.filter((item) => hobbyList?.includes(item.key)),
        interest: interestRaw
          ?.filter((item) => interestList?.includes(item.key)),
        specialNotes: controls?.specialNotes,
        photoProfilBase64: controls?.photoCustomerUrl,
        memberLevel: controls?.memberLevel?.value || null,
        loyaltyLevel: controls?.loyaltyLevel?.value || null,
      },
      dataProspect: {
        categoryProspect: controls.category?.value,
        prospectSource: controls.source?.value,
        idUserProspectOwner: auth?.user?.idUser,
        prospectType: controls.type?.value || "NEW",
        prospectDate:
          controls?.prospectDate || moment(new Date()).format("DD-MM-YYYY"),
      },
    },
    dataFollowUpProspect: {
      status: "ONGOING",
      followUpDate: moment().format("DD-MM-YYYY"),
    },
  };
};
